// Connectivity plugin.
import pluginInterface from '../interface'
import eventsMap from '../interface/events'
import { wsConnectFlow } from './sagas'

// Other plugins.
import { update as updateConfig } from '../../config/interface/actions'
import { mapEvents } from '../../events/interface/actions'

// Libraries.
import { put } from 'redux-saga/effects'
import { connCheckResponsibility } from '../../constants'

/**
 * Base Connectivity plugin factory.
 * Responsible for handling websockets.
 * @method baseConnectivity
 * @param  {Object} [options={}] Connectivity configs. See above.
 * @return {Object} Plugin - A connectivity plugin.
 */
export default function baseConnectivity (options) {
  // For backwards compatibility, convert the old style to the new style.
  if (typeof options.method === 'string') {
    const method = options.method
    options.method = {
      type: method,
      // In both old scenarios, the client is responsible.
      responsibleParty: connCheckResponsibility.CLIENT
    }
  }

  function * init () {
    yield put(updateConfig(options, pluginInterface.name))
    yield put(mapEvents(eventsMap))
  }

  return {
    sagas: [wsConnectFlow],
    init,
    name: pluginInterface.name,
    reducer: pluginInterface.reducer,
    api: pluginInterface.api
  }
}
